module.exports = __webpack_public_path__ + "static/media/yellow-cab@2x.da2fb639.png";